export default __webpack_public_path__ + "static/media/topping_rainbow Alpaca.20b99a8c.jpg";